import { Choice } from "./choice";

/** Represents a question that can be added to an exercise. */
export class Question {
  /** ID. */
  public id: number;

  /** Description used to make the question statement. */
  public description: string;

  /** Type of the question. */
  public type: number;

  /** List of available alternatives. */
  public alternatives: Choice[];

  /** Date of the last time the question was updated. */
  public lastChange: string;

  /** Tells whether the question is visible to the public or not. */
  public isActive: boolean;

  /** Tells whether the question has a relationship with another entity or not. */
  public isLinked: boolean;

  public alternativeAnswered: number;
  public correctAnswer: number;
  public isIncorrect: boolean;
  public attemptLimit: number;
  public attempts: number;
  public isCorrect: boolean;
  public questionType: number;
  public answeredAlternativeId: number;

  constructor(
    id = 0,
    description = "",
    type = 0,
    alternatives = new Array<Choice>(),
    lastChange = "",
    isActive = true,
    isLinked = false,
    alternativeAnswered = NaN,
    correctAnswer = NaN,
    isIncorrect = false,
    attemptLimit = NaN,
    attempts = NaN,
    isCorrect = false,
    questionType = 0,
    answeredAlternativeId = 0
  ) {
    this.id = id;
    this.description = description;
    this.type = type;
    this.alternatives = alternatives;
    this.lastChange = lastChange;
    this.isActive = isActive;
    this.isLinked = isLinked;
    this.alternativeAnswered = alternativeAnswered;
    this.correctAnswer = correctAnswer;
    this.isIncorrect = isIncorrect;
    this.attemptLimit = attemptLimit;
    this.attempts = attempts;
    this.isCorrect = isCorrect;
    this.questionType = questionType;
    this.answeredAlternativeId = answeredAlternativeId;
  }
}

export class Questionnaire {
  public id: number;
  public userId: number;
  public courseId: number;
  public contentId: number;
  public exerciseId: number;
  public minCorrectAnswers: number;
  public numberOfQuestions: number;
  public maximumTime: number;
  public createdAt: string;
  public finishedAt: string;

  constructor(
    id = 0,
    userId = 0,
    courseId = 0,
    contentId = 0,
    exerciseId = 0,
    minCorrectAnswers = 0,
    numberOfQuestions = 0,
    maximumTime = 0,
    createdAt = "",
    finishedAt = ""
  ) {
    this.id = id;
    this.userId = userId;
    this.courseId = courseId;
    this.contentId = contentId;
    this.exerciseId = exerciseId;
    this.minCorrectAnswers = minCorrectAnswers;
    this.numberOfQuestions = numberOfQuestions;
    this.maximumTime = maximumTime;
    this.createdAt = createdAt;
    this.finishedAt = finishedAt;
  }
}
